import React from "react";
import { motion } from "framer-motion";
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import {
  springVariants,
  springViewport,
} from "../utils/framerVariants";

const Image = ({ data }) => {
  const hasSpacing = data.ImageMargins?.startsWith("Less");
  const isMedium = data.ImageSize?.startsWith("Medium");
  const hasLink = data.LinkURL?.startsWith("http") || data.LinkURL?.startsWith("/");
  const isPortrait = data.portraitMode === true;

  // Define container and image classes
  let containerClass, imageClass;

  if (isPortrait) {
    containerClass = `container mx-auto ${isMedium ? "max-w-lg sm:px-6" : "max-w-xl sm:px-6"} ${hasSpacing ? "mb-16 md:mb-20" : "mb-16 md:mb-24 lg:mb-32 xl:mb-48"}`;
    imageClass = "aspect-DINA2";
  } else {
    containerClass = `container mx-auto ${isMedium ? "max-w-4xl lg:max-w-5xl 2xl:max-w-6xl" : "max-w-6xl lg:max-w-7xl 2xl:max-w-8xl"} px-0 md:px-24 lg:px-24 xl:px-24 ${hasSpacing ? "mb-16 md:mb-20" : "mb-16 md:mb-24 lg:mb-32 xl:mb-48"}`;
    imageClass = "aspect-3/2";
  }

  const image = data.Media && (
    <GatsbyImage
      className={imageClass}
      image={getImage(data.Media.file)}
      alt={data.Media.alternativeText || "Alternative Text missing"}
    />
  );

  const renderCaption = () => {
    if (data.captionText?.trim()) {
      return <div className="caption-rich-text" dangerouslySetInnerHTML={{ __html: data.captionText }} />;
    } else if (data.Media && data.Media.caption) {
      return <p className="inline-flex px-4 sm:px-0 mt-2 mb-0 text-text-sm tracking-text-sm leading-text-sm text-black/50 max-w-xl">{data.Media.caption}</p>;
    }
    return null;
  };

  return (
    <motion.article
      variants={springVariants}
      initial="invisible"
      whileInView="visible"
      viewport={springViewport}
      className={containerClass}>
      {hasLink ? (
        <div className="teaser-link">
          <a href={data.LinkURL} target={`_${data.LinkTarget}`}>
            {image}
          </a>
          {renderCaption()}
        </div>
      ) : (
        <>
          {image}
          {renderCaption()}
        </>
      )}
    </motion.article>
  );
};

export default Image;
